import type { AuthController } from "@firecms/core";

/**
 * 權限以 Firebase Auth 的 custom claims 為準（用 scripts/set-role.ts 設定）：
 *   admin：全部；staff：訂單、詢問、庫存
 * Firestore 安全規則也有同樣的限制，這裡只是讓畫面上不顯示沒有權限的操作。
 */
export type Roles = { admin: boolean; staff: boolean };

export function rolesOf(authController: AuthController): Roles {
  const extra = (authController.extra ?? {}) as Partial<Roles>;
  return { admin: extra.admin === true, staff: extra.staff === true || extra.admin === true };
}
